import Modal from "react-native-modal";
import { StyleSheet, View, Button, Text, Image, TouchableOpacity } from 'react-native'; //Modal
import FontAwesome from "@expo/vector-icons/FontAwesome";
import { useState, useEffect } from 'react';
import { db } from '../firebaseConfig';
import { doc, getDoc } from 'firebase/firestore';


// TODO: perhaps delete this component and use the one from react-native-modal
export default function ProfileModal({ message, visible, dismiss, userInfo }) {

  const [username2, setUsername2] = useState('');
  const [selectedImage2, setSelectedImage2] = useState(null);
  const [favoriteBar, setFavoriteBar] = useState('');

  useEffect(() => {
    (async () => {
      // const userRef2 = doc(db, "Users", userId);
      // const userSnap2 = await getDoc(userRef2);
      if (userInfo) {
        // console.log('userInfo: ', userInfo);
        if (userInfo.username) {
          setUsername2(userInfo.username);
          // console.log('userInfo.username: ', userInfo.username);
        }
        else
        {
          // username shouldn't be empty, but if it is, don't display anything so the modal doesn't display the last user's username.
          setUsername2('');
        }

        if (userInfo.storageImageUrl) {
          setSelectedImage2(userInfo.storageImageUrl);
        }
        else
        {
          // if image is empty don't display anything so the modal doesn't display the last user's image.
          setSelectedImage2(null);
        }

        // reset between profile clicks
        setFavoriteBar('');

        const userRef = doc(db, "Users", userInfo.userId);
        const userSnap = await getDoc(userRef);
        if (userSnap.data().favoriteBar) {
          setFavoriteBar(userSnap.data().favoriteBar);
        }
      }
    })();
  }, [userInfo])

  return (
    <Modal
      isVisible={visible}
      hasBackdrop={true}
      backdropColor="#EBBB40"
      backdropOpacity={0.6}
      onBackdropPress={dismiss}
      animationIn="zoomIn"
      animationOut="zoomOut"
    >
      <View style={styles.card}>
        <TouchableOpacity style={styles.closeButton} onPress={dismiss}>
          <FontAwesome name="close" size={18} color="#999" />
        </TouchableOpacity>

        <Image source={{ uri: selectedImage2 }} style={styles.userImage2} />

        <Text style={styles.username}>{username2}</Text>

        {favoriteBar &&
          <View style={styles.favoriteBarRow}>
            <FontAwesome name="star" size={14} color="#EBBB40" style={{ marginRight: 6 }} />
            <Text style={styles.favoriteBarText}>{favoriteBar}</Text>
          </View>
        }
      </View>
    </Modal>
  );
}

 
const styles = StyleSheet.create({
  card: {
    width: 260,
    backgroundColor: 'white',
    alignSelf: 'center',
    borderRadius: 16,
    paddingBottom: 20,
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.25,
    shadowRadius: 10,
    elevation: 6,
    overflow: 'hidden',
  },
  closeButton: {
    position: 'absolute',
    top: 8,
    right: 8,
    zIndex: 1,
    width: 28,
    height: 28,
    borderRadius: 14,
    backgroundColor: 'rgba(255,255,255,0.85)',
    alignItems: 'center',
    justifyContent: 'center',
  },
  userImage2: {
    width: '100%',
    height: 200,
    marginBottom: 14,
  },
  username: {
    fontSize: 18,
    fontWeight: '700',
    color: '#333',
    textAlign: 'center',
  },
  favoriteBarRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 8,
    paddingHorizontal: 16,
    paddingVertical: 6,
    backgroundColor: '#F5F2FC',
    borderRadius: 999,
  },
  favoriteBarText: {
    fontSize: 14,
    fontWeight: '600',
    color: '#674FE0',
  },
});
